import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

/* Mattoni condivisi delle guide (Guida SMM, Guida ai trend): layout con indice, blocchi, passi, link. */

export function L({ to, children }) {
  return <Link to={to} style={{ color: 'var(--cyan)', fontWeight: 600, textDecoration: 'none' }}>{children}</Link>;
}

export function A({ href, children }) {
  const esterno = /^https?:/.test(href);
  return (
    <a href={href} {...(esterno ? { target: '_blank', rel: 'noreferrer' } : {})}
      style={{ color: 'var(--cyan)', fontWeight: 600, textDecoration: 'none' }}>{children}</a>
  );
}

export function Blocco({ id, Icon, titolo, sotto, children }) {
  return (
    <section id={id} className="eden-card" style={{ padding: '22px 24px', marginBottom: 16, scrollMarginTop: 'calc(var(--topbar-h) + 16px)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: sotto ? 4 : 14 }}>
        <span style={{ width: 30, height: 30, borderRadius: 9, background: 'var(--cyan-dim)', color: 'var(--cyan)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon size={16} />
        </span>
        <h2 style={{ fontSize: 17, fontWeight: 700, margin: 0, color: 'var(--text)' }}>{titolo}</h2>
      </div>
      {sotto && <p style={{ margin: '0 0 16px 40px', fontSize: 13.5, color: 'var(--text-muted)' }}>{sotto}</p>}
      <div style={{ fontSize: 14, lineHeight: 1.6, color: 'var(--text-muted)' }}>{children}</div>
    </section>
  );
}

export function Passi({ items }) {
  return (
    <ol style={{ margin: 0, paddingLeft: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
      {items.map((it, i) => (
        <li key={i} style={{ display: 'flex', gap: 12 }}>
          <span style={{ width: 22, height: 22, borderRadius: '50%', border: '1px solid var(--border-h)', fontSize: 11.5, fontWeight: 700, color: 'var(--text)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>{i + 1}</span>
          <span>{it}</span>
        </li>
      ))}
    </ol>
  );
}

/** Pagina guida: intestazione + indice (laterale su desktop, chip su telefono) che segue la lettura. */
export function GuidaLayout({ Icon, titolo, sottotitolo, sezioni, azioni, children }) {
  const [attiva, setAttiva] = useState(sezioni[0]?.id);
  useEffect(() => {
    const obs = new IntersectionObserver(entries => {
      const vis = entries.filter(e => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (vis) setAttiva(vis.target.id);
    }, { rootMargin: '-80px 0px -60% 0px' });
    sezioni.forEach(s => { const el = document.getElementById(s.id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, [sezioni]);

  return (
    <div className="eden-page" style={{ maxWidth: 1100 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20, flexWrap: 'wrap' }}>
        <span style={{ width: 44, height: 44, borderRadius: 12, background: 'var(--cyan-dim)', color: 'var(--cyan)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon size={22} />
        </span>
        <div style={{ flex: 1, minWidth: 220 }}>
          <h1 style={{ margin: 0 }}>{titolo}</h1>
          <div style={{ fontSize: 13.5, color: 'var(--text-muted)', marginTop: 4 }}>{sottotitolo}</div>
        </div>
        {azioni}
      </div>
      <div className="eden-guida">
        <nav className="eden-guida-toc" aria-label="Indice della guida">
          {sezioni.map(s => (
            <a key={s.id} href={`#${s.id}`} className={`eden-guida-toc-item${attiva === s.id ? ' is-active' : ''}`}>
              <s.Icon size={14} />{s.label}
            </a>
          ))}
        </nav>
        <div style={{ minWidth: 0 }}>{children}</div>
      </div>
    </div>
  );
}
